import { useEffect } from 'react'

import type { UserGroupOption } from '../types/api.types'
import { EVERYONE_GROUP_NAME } from '../utils/extensions'

/**
 * Auto-select the "Everyone" user group when creating new extensions.
 */
export const useAutoSelectEveryoneGroup = (
  isAddMode: boolean,
  allUserGroups: UserGroupOption[],
  setUserGroupIds: (updater: (prev: number[]) => number[]) => void,
) => {
  useEffect(() => {
    if (!isAddMode || allUserGroups.length === 0) return
    setUserGroupIds((prev) => {
      if (prev.length > 0) return prev
      const everyoneGroup = allUserGroups.find(
        (group) =>
          group.name === EVERYONE_GROUP_NAME && group.auto_generated === true,
      )
      return everyoneGroup ? [everyoneGroup.id] : []
    })
  }, [isAddMode, allUserGroups, setUserGroupIds])
}
